export default __webpack_public_path__ + "resources/icons/d332-78b7.png";